function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { ThumbnailListEntry } from '../../molecules';
import { CallToAction, Container, Heading } from '../../atoms';
import { LightArrowRight } from '../../visuals';
export default function ThumbnailListEntriesSection(param) {
    var title = param.title, action = param.action, entries = param.entries, className = param.className;
    return /*#__PURE__*/ React.createElement(Container, {
        name: ThumbnailListEntriesSection.name,
        background: "custom",
        className: twMerge('bg-green-700', className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-7 grid-cols-1 grid-areas-[title,cards,action] md:grid-cols-[1fr_auto] md:grid-areas-[title_action,cards_cards]",
        style: {
            '--colors-button-main-bg-base': 'var(--colors-neutral-900)',
            '--colors-button-main-bg-base-rgb': 'var(--colors-neutral-900-rgb)',
            '--colors-button-main-bg-hover': 'var(--colors-neutral-900)',
            '--colors-button-main-bg-hover-rgb': 'var(--colors-neutral-900-rgb)'
        }
    }, !!title && /*#__PURE__*/ React.createElement("div", {
        className: "grid-in-[title] text-fg-inverted"
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h2",
        variant: "h2"
    }, title)), !!action && /*#__PURE__*/ React.createElement("div", {
        className: "grid-in-[action] my-auto"
    }, /*#__PURE__*/ React.createElement(CallToAction, _object_spread_props(_object_spread({}, action), {
        icon: /*#__PURE__*/ React.createElement(LightArrowRight, null),
        className: "[&>button]:text-fg-inverted [&>button]:bg-button-main-bg-base/10 [&>button]:border-transparent [&>button]:hover:bg-button-main-bg-base/30 [&>button]:hover:border-transparent w-full"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "grid-in-[cards] grid grid-cols-1 grid-flow-row auto-cols-max md:gap-7 md:grid-cols-3"
    }, entries.map(function(entry, entryIndex) {
        return /*#__PURE__*/ React.createElement("div", {
            key: "card-".concat(entry.title)
        }, entryIndex > 0 && /*#__PURE__*/ React.createElement("div", {
            role: "presentation",
            className: "my-7 bg-fg-inverted/20 h-nudge md:hidden"
        }), /*#__PURE__*/ React.createElement(ThumbnailListEntry, _object_spread({
            variant: "inverted"
        }, entry)));
    }))));
}

//# sourceMappingURL=ThumbnailListEntriesSection.js.map